import { render, staticRenderFns } from "./TenancyDepositSubscriptionRelease.vue?vue&type=template&id=007f8c3a&"
import script from "./TenancyDepositSubscriptionRelease.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositSubscriptionRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports